import { registerPlugin } from '@capacitor/core';
import { withBridgedStackTrace } from '../withBridgedStackTrace';

import { SharePluginInterface } from './definitions';
import { CAPACITOR_SHARE_PLUGIN_NAME } from '../pluginConstants';

const SharePluginRaw = registerPlugin<SharePluginInterface>(CAPACITOR_SHARE_PLUGIN_NAME);
const SharePlugin = withBridgedStackTrace(SharePluginRaw, CAPACITOR_SHARE_PLUGIN_NAME);

export * from './definitions';
export { SharePlugin };
